import { getTableColumn, TableColumn } from '@shared/UI';
import { useClientDetailsTable } from './AssignPositionTableProvider';
import { getHeaderClassName } from '@shared/UI/SimpleTable/lib/getHeaderClassName';
import { HeaderCellWithFilter } from '@shared/UI/SimpleTable/components/HeaderCellWithFilter';

export function getTransactionsTableColumns(): TableColumn<any>[] {
    const { desc, sortFieldName, arrayWithLogos } = useClientDetailsTable();

    const statusStyles = {
        Bought: { backgroundColor: '#ECFDF6', color: '#047857', borderColor: '#CEF5E6' },
        Sold: { backgroundColor: '#FCF1F1', color: '#B91C1C', borderColor: '#FEE2E2' },
    };

    const columns: TableColumn<any>[] = [
        getTableColumn({
            title: 'ticker',
            flex: 0.15,
            formatter: (_, row) => {
                return (
                    <div className='positions-table-cell'>
                        {!!arrayWithLogos.find((item) => item.symbol === row.security.symbol)?.link ? (
                            <img
                                className='positions-table-cell__logos'
                                src={arrayWithLogos.find((item) => item.symbol === row.security.symbol)?.link}
                                alt='logo'
                            />
                        ) : (
                            <div className='positions-table-cell__logos placeholder' />
                        )}
                        <span>{row.security.symbol}</span>
                    </div>
                );
            },
            headerClassName: `positions-table-header ${getHeaderClassName(sortFieldName, desc, 'security.symbol')}`,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title={String(row)}
                    icon={undefined}
                    onClick={() => null}
                />
            ),
        }),
        getTableColumn({
            dataField: 'security.cusip',
            flex: 0.15,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='CUSIP'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'security.cusip')}`,
        }),
        getTableColumn({
            dataField: 'account.verificationRequest.firstName',
            flex: 0.15,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='First Name'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'account.verificationRequest.firstName')}`,
        }),

        getTableColumn({
            dataField: 'account.verificationRequest.lastName',
            flex: 0.15,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Last Name'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'account.verificationRequest.lastName')}`,
        }),
        getTableColumn({
            dataField: 'quantity',
            flex: 0.1,
            firstColumn: true,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Quantity'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'Quantity')}`,
        }),
        getTableColumn({
            dataField: 'quantity',
            flex: 0.15,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Operation'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header`,
            formatter: (_, row) => {
                const status = row.quantity > 0 ? 'Bought' : 'Sold';

                // Use status to get the corresponding style
                const style = statusStyles[status] || {
                    backgroundColor: '#E4E4E4',
                    borderColor: '#E4E4E4',
                    color: '#000',
                };
                return (
                    <span
                        style={{
                            display: 'inline-block',
                            padding: '4px 10px',
                            borderRadius: '8px',
                            backgroundColor: style.backgroundColor,
                            color: style.color,
                            border: `1px solid ${style.borderColor}`,
                            fontWeight: 500,
                        }}
                    >
                        {row.quantity > 0 ? 'Bought' : 'Sold'}
                    </span>
                );
            },
        }),
        getTableColumn({
            dataField: 'securityId',
            flex: 0.15,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Security Id'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'securityId')}`,
        }),
        getTableColumn({
            dataField: 'averagePrice',
            flex: 0.15,
            headerFormatter: (row) => (
                <HeaderCellWithFilter
                    title='Average Price'
                    icon={undefined}
                    onClick={() => null}
                />
            ),
            headerClassName: `transactions-table-header ${getHeaderClassName(sortFieldName, desc, 'averagePrice')}`,
        }),
    ];

    return columns;
}
